import { render, staticRenderFns } from "./UserIndicators.vue?vue&type=template&id=1307bd62"
import script from "./UserIndicators.vue?vue&type=script&lang=js"
export * from "./UserIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports